var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg004Man(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 464 464",
    height: 512,
    viewBox: "0 0 464 464",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m408.5 112c0 4.42-3.58 8-8 8h-67v54c0 13.81-11.19 25-25 25v3.13c0 41.27-25.25 76.64-61.15 91.5l.15.37c0 6.971-1.673 25.497 15.7 39.24 6.97 5.51 15.77 8.84 25.33 8.93 41.23.39 74.97 32.95 74.97 74.18v39.65c0 4.42-3.58 8-8 8h-292c-4.42 0-8-3.58-8-8v-39.65c0-41.23 33.74-73.79 74.97-74.18 22.584-.213 41.03-18.508 41.03-41.34v-6.83l.15-.37c-35.9-14.86-61.15-50.23-61.15-91.5v-3.13c-14.252 0-25-11.262-25-24.54v-78.46c0-53.02 42.98-96 96-96h56c53.02 0 96 42.98 96 96v8h67c4.42 0 8 3.58 8 8z",
    fill: "#ffdfba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m333.5 120v54c0 13.81-11.19 25-25 25 0-12.72 0-54.94 0-79z",
    fill: "#ffe773"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m408.5 112c0 4.42-3.58 8-8 8h-315v-24c0-53.02 42.98-96 96-96h56c53.02 0 96 42.98 96 96v8h67c4.42 0 8 3.58 8 8z",
    fill: "#fe4f60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m308.5 202.13c0 54.696-44.348 99-99 99-51.492 0-99-40.031-99-102.13v-79h198z",
    fill: "#ffebd2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m363.5 416.35v39.65c0 4.42-3.58 8-8 8h-292c-4.42 0-8-3.58-8-8v-39.65c0-41.23 33.74-73.79 74.97-74.18 9.56-.09 18.36-3.42 25.33-8.93 8.033 8.033 20.737 18.755 24.37 40.52 18.029 8.228 42.106 7.762 58.58.51 3.469-21.956 16.201-32.781 24.45-41.03 6.97 5.51 15.77 8.84 25.33 8.93 41.23.39 74.97 32.95 74.97 74.18z",
    fill: "#fe4f60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m238.75 374.27c-1.037 6.428-.76 2.023-.76 89.73h-56.98c0-87.595.304-83.46-.84-90.24 18.124 8.268 42.199 7.714 58.58.51z",
    fill: "#42434d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m194.01 464h-13c0-87.595.304-83.46-.84-90.24 4.25 1.94 8.84 3.4 13.57 4.39.382 4.009.27-1.191.27 85.85z",
    fill: "#2c2c33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m110.5 120v79c-14.255 0-25-11.265-25-24.54v-54.46z",
    fill: "#ffec8f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m140.5 120v62.13c0 36.51 19.192 66.79 46.584 83.927 16.277 10.183 3.442 35.156-14.376 28.004-36.634-14.704-62.208-50.404-62.208-91.932v-82.129z",
    fill: "#fff3e4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m248.63 310.42c-24.637 10.313-51.712 11.113-78.26 0 1.356-5.626 1.13-9.27 1.13-16.42l.15-.37c24.082 9.996 51.571 10.016 75.7 0l.15.37c0 7.153-.226 10.796 1.13 16.42z",
    fill: "#ffd6a6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m156.354 368.169c-41.172.276-74.854 32.751-74.854 73.924v21.907h-18c-4.418 0-8-3.582-8-8v-39.645c0-41.236 33.736-73.797 74.971-74.187 9.565-.09 18.356-3.415 25.329-8.928 4.146 4.146 8.147 7.884 11.771 12.347 7.035 8.661 1.899 22.494-11.217 22.582z",
    fill: "#ff6d7a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m262.646 368.169c41.172.276 74.854 32.751 74.854 73.924v21.907h18c4.418 0 8-3.582 8-8v-39.645c0-41.236-33.737-73.797-74.971-74.187-9.565-.09-18.356-3.415-25.329-8.928-4.146 4.146-8.147 7.884-11.771 12.347-7.035 8.661-1.899 22.494 11.217 22.582z",
    fill: "#e84857"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m272.641 6.635c12.513 4.925 8.871 23.444-4.576 23.366-.462-.002-56.103-.001-56.565-.001-47.497 0-86.945 34.494-94.636 79.807-.995 5.863-6 10.193-11.946 10.193h-19.418v-24c0-53.019 42.981-96 96-96h56c12.404 0 24.258 2.352 35.141 6.635z",
    fill: "#ff6d7a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg004Man);
export default __webpack_public_path__ + "static/media/004-man.8ecaf35958e31e0dc952d3b0c9ca2f24.svg";
export { ForwardRef as ReactComponent };